import React from 'react';
import { Navigate } from 'react-router-dom';

import DefaultLayout from 'src/layouts/DefaultLayout';
import MainLayout from 'src/layouts/MainLayout';
import AdmLayout from 'src/layouts/AdmLayout';
import ConfLayout from 'src/layouts/ConfLayout';

import ManagLayout from 'src/layouts/ManagLayout';
import SupportLayout from 'src/layouts/SupportLayout';
import FinancialLayout from 'src/layouts/FinancialLayout';

import NotFoundView from 'src/errors/NotFoundView';

import Login from 'src/views/auth/login';
import Logout from 'src/views/auth/logout';
import Register from 'src/views/auth/register';
import Activation from 'src/views/auth/activation';

import Monitoring from 'src/main/monitoring';
import Alarms from 'src/views/alarms/alarms';
import Dashboard from 'src/views/alarms/dashboard';
import Histories from 'src/views/alarms/histories';

import Administrating from 'src/main/administrating';
import Company from 'src/views/company';
import Locations from 'src/views/locations';
import Users from 'src/views/users';
import Groups from 'src/views/groups';
import Mailing from 'src/views/mailing';
import Equipments from 'src/views/equipments';

import Configuring from 'src/main/configuring';
import Devices from 'src/views/devices';
import Hardwares from 'src/views/hardwares';
import Messages from 'src/views/messages';
import Panels from 'src/views/panels';
import Settings from 'src/views/settings';
import Operations from 'src/views/operations';

import Management from 'src/main/management';
import Contracts from 'src/views/contracts';
import Units from 'src/views/units';
import Occurrences from 'src/views/occurrences';
import Products from 'src/views/products';
import ProductsLpu from 'src/views/productslpu';
import Stocks from 'src/views/stocks';
import Inventories from 'src/views/inventories';
import Reports from 'src/views/reports';
import Others from 'src/views/others';
import Budgets from 'src/views/budgets';
import Imports from 'src/views/imports';

import Supporting from 'src/main/supporting';
import Trackings from 'src/views/trackings';
import Agendas from 'src/views/agendas';
import Timeline from 'src/views/timeline';
import Supports from 'src/views/supports';
import Partitions from 'src/views/partitions';
import Launching from 'src/views/launching';

import Financial from 'src/main/financial';
import Billings from 'src/views/billings';
import Audit from 'src/views/audit';

import Storage from 'src/views/storage';

const routes = [
  {
    path: '/',
    element: <DefaultLayout />,
    children: [
      { path: 'login', element: <Login /> },
      { path: 'logout', element: <Logout /> },
      { path: 'activation/:device', element: <Activation /> },
      { path: 'register', element: <Register /> },
      { path: '/', element: <Navigate to="/login" /> },
      { path: '404', element: <NotFoundView /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'mon',
    element: <MainLayout />,
    children: [
      { path: 'main', element: <Monitoring /> },
      { path: 'locations', element: <Locations /> },
      { path: 'alarms', element: <Alarms /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'history', element: <Histories /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'adm',
    element: <AdmLayout />,
    children: [
      { path: 'main', element: <Administrating /> },
      { path: 'company', element: <Company /> },
      { path: 'locations', element: <Locations /> },
      { path: 'users', element: <Users /> },
      { path: 'groups', element: <Groups /> },
      { path: 'mailing', element: <Mailing /> },
      { path: 'equipments', element: <Equipments /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'cfg',
    element: <ConfLayout />,
    children: [
      { path: 'main', element: <Configuring /> },
      { path: 'settings', element: <Settings /> },
      { path: 'panels', element: <Panels /> },
      { path: 'devices', element: <Devices /> },
      { path: 'hardwares', element: <Hardwares /> },
      { path: 'messages', element: <Messages /> },
      { path: 'operations', element: <Operations /> },
      { path: 'storage', element: <Storage /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'mgt',
    element: <ManagLayout />,
    children: [
      { path: 'main', element: <Management /> },
      { path: 'contracts', element: <Contracts /> },
      { path: 'units', element: <Units /> },
      { path: 'occurrences', element: <Occurrences /> },
      { path: 'products', element: <Products /> },
      { path: 'productslpu', element: <ProductsLpu /> },
      { path: 'stocks', element: <Stocks /> },
      { path: 'reports', element: <Reports /> },
      { path: 'others', element: <Others /> },
      { path: 'budgets', element: <Budgets /> },
      { path: 'imports', element: <Imports /> },
      { path: 'inventories', element: <Inventories /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'sup',
    element: <SupportLayout />,
    children: [
      { path: 'main', element: <Supporting /> },
      { path: 'supports', element: <Supports /> },
      { path: 'partitions', element: <Partitions /> },
      { path: 'launching', element: <Launching /> },
      { path: 'trackings', element: <Trackings /> },
      { path: 'agendas', element: <Agendas /> },
      { path: 'timeline', element: <Timeline /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: 'fin',
    element: <FinancialLayout />,
    children: [
      { path: 'main', element: <Financial /> },
      { path: 'billings', element: <Billings /> },
      { path: 'audit', element: <Audit /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
